import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f14c0a04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "view",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "view1",
    src: "http://127.0.0.1:38088/video=stream&camidx=0",
    alt: "主摄像头"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    id: "view2",
    src: "http://127.0.0.1:38088/video=stream&camidx=1",
    alt: "副摄像头"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "开票信息")
], -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("增值税普通发票")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("个人发票（无需填写单位信息）")
const _hoisted_6 = {
  key: 0,
  class: "in"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "学员信息")
], -1))
const _hoisted_8 = { class: "in" }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("获取")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("自提")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("快递（到付）")
const _hoisted_15 = { class: "card-header" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "其他附件", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("查看历史证书")
const _hoisted_18 = { class: "in" }
const _hoisted_19 = { class: "bottom" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("取消")

import axios from 'axios'
  import { ref, onMounted, reactive } from 'vue'
  import {GETAuth, POST, POSTAuth} from '@/service/index'
  import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
  import ImgBox from '../../components/ImgBox.vue'
  import Certificate from '../../components/Certificate.vue'
  import { useRouter } from 'vue-router'
  import 'dayjs/locale/zh-cn'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const isShow:any = ref(false)
  const srcList:any = ref([])
  let companyList:any = []
  const loading:any = ref(false)
  const timeList:any = []
  const item = {
    src: ''
  }
  const certificate = ref(null)

  const router = useRouter();

  onMounted(() => {
    getPeriodTime()
    getTrainingSubjectCategory()
    getConfigSubDistrictCategory()
    getCourse()
    getProvince()
    getDegreeCategory()
  })

  const form = reactive({
    invoicechoose: ref(1),
    studentname: ref(''),
    gender: ref(''),
    birthdate: ref(''),
    phoneno: ref(''),
    idcardname: ref(''),
    idcardcode: ref(''),
    idcardno: ref(''),
    invoicecode: ref('INV_001'),
    invoicename: ref('增值税普通发票'),
    positioncode: ref(''),
    positiontype: ref(''),
    inchargecode: ref(''),
    inchargename: ref(''),
    provincekey: ref(10),
    zsprovincekey: ref(10),
    province: ref(''),
    zsprovince: ref(''),
    cprovince: ref(''),
    citykey: ref(66),
    zscitykey: ref(66),
    city: ref(''),
    zscity: ref(''),
    ccity: ref(''),
    districtkey: ref(700),
    zsdistrictkey: ref(700),
    district: ref(''),
    zsdistrict: ref(''),
    cdistrict: ref(''),
    townkey: ref(''),
    zstownkey: ref(''),
    town: ref(''),
    zstown: ref(''),
    ctown: ref(''),
    region: ref(''),
    ddlTrainTime: ref(''),
    traintime: ref(''),
    bankaccountno: ref(''),
    bankaddress: ref(''),
    companyaddress: ref(''),
    companycode: ref(''),
    companyname: ref(''),
    degreecode: ref('DEG_007'),
    degreename: ref('大专'),
    certificatetime: ref(''),
    contact: ref(''),
    contactphone: ref(''),
    depositbank: ref(''),
    invoicetitle: ref(''),
    paymentCode: ref('PAY_003'),
    paymentName: ref('线下支付'),
    subdistrict: ref(''),
    taxno: ref(''),
    coursename: ref(''),
    subjectname: ref(''),
    subjectcode: ref(''),
    coursecode: ref(''),
    coursefee: ref(''),
    stagecode:  ref(''),
    stagename: ref(''),
    audienceName: ref(''),
    profilephotopath: ref(''),
    idcardfrontphotopath: ref(''),
    idcardbackendphotopath: ref(''),
    diplomafile: ref(''),
    certfirst: ref(''),
    certsecond: ref(''),
    file01: ref(''),
    file02: ref(''),
    file03: ref(''),
    file04: ref(''),
    file05: ref(''),
    file06: ref(''),
    sort: ref(''),
    kttype: ref(1),
    ktname: ref(''),
    ktphone: ref(''),
    nameremark: ref(''),
  })

  const backHandler = () => {
    router.replace({
      name: 'Home'
    })
  }
  
  const setParams = (type:string, value:string) => {
    if ( isNaN(type) ) {
      form[type] = value
    } else {
      form['file'+type] = value
    }
  }

  const getStudent = async () => {
    let { data } = await GETAuth(`/common/get_student_code`, {
      params: { idcardno: form.idcardno }
    })
    if ( data.code === 200 && data.data ) {
      form.studentcode = data.data.studentcode
    }
  }


  const openTime:any = ref("请选择开班日期")
  const trainTimeHandler = (e:string) => {
    let time = e.split('|')
    let item = timeList.value.find((i:any) => i.periodid == time[0])
    if ( item ) {
      form.traintime = `${item.startdate} 至 ${item.enddate}`
      openTime.value = item.remarks
    }
  }


  const provinces:any = ref([])
  const getProvince = async () => {
    let { data }  = await GETAuth(`/common/province`)
    if ( data.code === 200 ) {
      let temp:any = []
      data.data.forEach((i:any) => {
        temp.push({
          label: i.proname,
          value: i.proid
        })
      })
      provinces.value = temp
      changeProvince('10')
      zschangeProvince('10')
    }
  }

  // 组装开票信息
  const invoiceHandler = (e:string) => {
    if ( e === '1' ) {
      form.idcardcode = 'INV_001'
      form.invoicename = "增值税普通发票"
    } else if ( e === '2' ) {
      form.invoicecode = 'INV_002'
      form.invoicename = "个人发票"
    } else if ( e === '3' ) {
      form.invoicecode = 'INV_003'
      form.invoicename = "电子发票"
    }
  }

  // 组装学历
  const degreeHandler = (e:string) => {
    let item = degreeCategory.value.find((key:any) => key.value == e )
    form.degreecode = item.value
    form.degreename = item.label
  }

  // 证件类型
  const idcardHandler = (e:string) => {
    if ( e === 'IDC_001' ) {
      form.idcardcode = 'IDC_001'
      form.idcardname = "身份证"
    } else if ( e === 'IDC_002' ) {
      form.idcardcode = 'IDC_002'
      form.idcardname = "港澳台胞证"
    } else if ( e === 'IDC_003' ) {
      form.idcardcode = 'IDC_003'
      form.idcardname = "护照"
    }
  }

  const citys:any = ref([])
  const changeProvince = async (e:string) => {
    let province = provinces.value.find((item:any) => item.value == e)
    if ( province ) {
      form.province = province.label
      form.cprovince = province.label
    }
    let { data }  = await GETAuth(`/common/city`, {
      params: {proid: e}
    })
    citys.value=[]
    changeDistrict.value=[]
    if ( data.code === 200 ) {
      let temp:any = []
      data.data.forEach((i:any) => {
        temp.push({
          label: i.cityname,
          value: i.cityid
        })
      })
      citys.value = temp
      changeDistrict('66')
    }
  }

  const zscitys:any = ref([])
  const zschangeProvince = async (e:string) => {
    let province = provinces.value.find((item:any) => item.value == e)
    if ( province ) {
      form.zsprovince = province.label
    }
    let { data }  = await GETAuth(`/common/city`, {
      params: {proid: e}
    })
    zscitys.value=[]
    zschangeDistrict.value=[]
    if ( data.code === 200 ) {
      let temp:any = []
      data.data.forEach((i:any) => {
        temp.push({
          label: i.cityname,
          value: i.cityid
        })
      })
      zscitys.value = temp
      zschangeDistrict('66')
    }
  }

  const districts:any = ref([])
  const changeDistrict = async (e:any) => {
    let city = citys.value.find((item:any) => item.value == e)
    if ( city ) {
      form.city = city.label
      form.ccity = city.label
    }
    let { data }  = await GETAuth(`/common/district`, {
      params: {cityid: e}
    })
    if ( data.code === 200 ) {
      let temp:any = []
      data.data.forEach((i:any) => {
        temp.push({
          label: i.disname,
          value: i.id
        })
      })
      districts.value = temp
      changeArea('700')
    }
  }

  const zsdistricts:any = ref([])
  const zschangeDistrict = async (e:any) => {
    let city = citys.value.find((item:any) => item.value == e)
    if ( city ) {
      form.zscity = city.label
    }
    let { data }  = await GETAuth(`/common/district`, {
      params: {cityid: e}
    })
    if ( data.code === 200 ) {
      let temp:any = []
      data.data.forEach((i:any) => {
        temp.push({
          label: i.disname,
          value: i.id
        })
      })
      zsdistricts.value = temp
      zschangeArea('700')
    }
  }

  const changeArea = (e:string) => {
    let district = districts.value.find((item:any) => item.value == e)
    if ( district ) {
      form.district = district.label
      form.cdistrict = district.label
    }
  }

  const zschangeArea = (e:string) => {
    let district = zsdistricts.value.find((item:any) => item.value == e)
    if ( district ) {
      form.zsdistrict = district.label
    }
  }

  const townHandler = (e:string) => {
    let town = district.value.find((item:any) => item.value == e)
    if ( town ) {
      form.town = town.label
      form.ctown = town.label
    }
  }

  const zstownHandler = (e:string) => {
    let town = district.value.find((item:any) => item.value == e)
    if ( town ) {
      form.zstown = town.label
    }
  }

  const onSubmit = async () => {
    if ( form.invoicechoose === 2 ) {
      if ( !form.invoicetitle ) {
        ElMessage.error("请选择开票信息")
        return
      }
    }
    if ( form.invoicetitle == '' ) {
      form.invoicetitle = form.companyname
    }
    if ( !form.studentname ) {
      ElMessage.error("请获取用户信息")
      return
    }
    if ( !form.traintime ) {
      ElMessage.error("请选择培训日期")
      return
    }
    if ( !form.phoneno ) {
      ElMessage.error("请选择填写联系电话")
      return
    }

    let res = await POST('/api/create_enroll_record', form);
    let { data } = res
    if ( data.code === 200 ) {
      ElMessageBox.confirm('报名成功','提示', {
            confirmButtonText: '返回首页',
            cancelButtonText: '继续报名',
            type: 'warning',
          }
      ).then(() => {
        router.replace({
          name: 'Home'
        })
      }).catch(() => {
        location.reload();
      })
    } else {
      ElMessage.error(data.msg)
    }
  }

  const formatTime = (time:string) => {
    return `${time.substring(0, 4)}-${time.substring(4,6)}-${time.substring(6,8)}`
  }

  const getUserInfo = async () => {
    const loadingInstance = ElLoading.service({ fullscreen: true, text: '获取身份证信息' })
    let { status, data: { IDCardInfo, code } } = await axios.post('http://127.0.0.1:38088/card=idcard')
    loadingInstance.close()
    if ( status === 200 ) {
      if ( code === '0' ) {
        form.studentname = IDCardInfo.name
        form.gender = IDCardInfo.sex
        form.idcardno = IDCardInfo.cardID
        form.birthdate = formatTime(IDCardInfo.birthday)
        form.idcardfrontphotopath = IDCardInfo.photoBase64_Z
        form.idcardbackendphotopath = IDCardInfo.photoBase64_F
        form.profilephotopath = IDCardInfo.photoBase64
        form.idcardcode = 'IDC_001'
        form.idcardname = "身份证"
        getStudent()
      } else {
        ElMessage.error("未检测到身份证信息！")
      }
    } else {
      ElMessage.error("高拍仪调用失败！")
    }
  }

  const degreeCategory:any = ref([])
  const getDegreeCategory = async () => {
    let { data }  = await GETAuth(`/common/config_degree_category`)
    if ( data.code === 200 ) {
      if ( data.data.length > 0 ) {
        let temp:any = []
        data.data.forEach((i:any) => {
          temp.push({
            label: i.degreename,
            value: i.degreecode
          })
        })
        degreeCategory.value = temp
      }
    } else {
      ElMessage.error("未获取到数据")
    }
  }

  const getCourse = async () => {
    const { params } = router.currentRoute.value
    if ( params.TrainingStage !== 'TSG_001' ) {
      isShow.value = true
    }
    let { data }  = await GETAuth(`/common/course_one`, {
      params: {
        subjectcode: params.SubjectCode,
        audiencecode: params.AudienceCode,
        stagecode: params.TrainingStage,
      }
    })
    if ( data.code === 200 ) {
      if ( data.data.length > 0 ) {
        let temp = data.data[0] || {}
        form.stagecode = params.TrainingStage.toString()
        form.stagename = params.TrainingStage == 'TSG_001' ? '初训' : params.TrainingStage == 'TSG_002' ? '复训' : '换证'
        form.audienceName = temp.audienceName
        form.positioncode = temp.audiencecode
        form.positiontype = temp.audienceName
        form.subjectname = temp.subjectName
        form.subjectcode = temp.subjectcode
        form.coursename = temp.coursename
        form.coursecode = temp.coursecode
        form.coursefee = temp.coursefee
        getFiles(temp.files)
      }
    } else {
      ElMessage.error("未获取到数据")
    }
  }

  const files = ref()
  const getFiles = async (ids:any) => {
    let { data }  = await GETAuth(`/common/config_file`, {
      params: {
        ids: ids
      }
    })
    if ( data.code === 200 ) {
      let temp:any = []
      data.data.forEach(i => {
        i.imgurl = `/out/${i.imgurl}`
        temp.push(i.imgurl)
      })
      files.value = data.data
      srcList.value = temp
    }
  }

  const periodids:any = ref([])
  const getPeriodTime = async () => {
    const { params } = router.currentRoute.value
    let { data }  = await GETAuth(`/common/enroll_period`, {
      params: {
         subjectcode: params.SubjectCode,
         audiencecode: params.AudienceCode,
         stagecode: params.TrainingStage,
         status: 1
      }
    })
    if ( data.code === 200 ) {
      if ( data.data.length > 0 ) {
        let temp:any = []
        data.data.forEach((i:any) => {
          temp.push({
            label: i.enrolltype === 1 ? `${i.startdate}【${i.classname}】【${i.address}】` : `预报名(${i.remarks})-${i.classname}【${i.address}】`,
            value: `${i.periodid}|${i.classcode}`
          })
        })
        periodids.value = temp
        timeList.value = data.data
      } else {
        alert("当前开班不足！")
        router.replace({
          name: 'Home'
        })
      }
    } else {
      ElMessage.error("未获取到相关信息！")
    }
  }

  const district = ref()
  const getConfigSubDistrictCategory = async () => {
    let { data }  = await GETAuth(`/common/config_sub_district_category`)
    if ( data.code === 200 ) {
      let temp:any = []
      data.data.forEach((i:any) => {
        temp.push({
          label: i.subdistrictname,
          value: i.subdistrictname
        })
      })
      district.value = temp
    } else {
      ElMessage.error("未获取到相关信息！")
    }
  }

  const getTrainingSubjectCategory = async () => {
    let { data }  = await GETAuth(`/common/training_subject_category`)
    if ( data.code === 200 ) {
      // console.log(data)
    } else {
      ElMessage.error("未获取到相关信息！")
    }
  }

  const companys = ref([])
  const getConfigCompany = async (e:any) => {
    let { data }  = await GETAuth(`/common/config_company`, {
      params: {
        companyname: e
      }
    })
    if ( data.code === 200 ) {
      let temp:any = []
      data.data.forEach((item:any) => {
        temp.push({
          label: item.companyname,
          value: item.companycode
        })
      })
      companyList = data.data
      companys.value = temp
    }
  }

  const changeCompany = (e:any) => {
    let item = companyList.find((i:any) => i.companycode == e)
    if ( item ) {
      for ( let n in item  ) {
        form[n] = item[n]
      }
    } else {
      let map = {
        bankaccountno: '',
        bankaddress: '',
        companyaddress: '',
        companycode: '',
        companyname: '',
        contact: '',
        contactphone: '',
        depositbank: '',
        invoicetitle: '',
        subdistrict: '',
        taxno: ''
      }
      for ( let n in map  ) {
        form[n] = map[n]
      }
    }
  }

  const isLoading = ref(false)
  const showCertificate = () => {
    isLoading.value = true
    certificate.value.getInfo()
  }

  const hideCertificate = () => {
    isLoading.value = false
  }




return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_container, { class: "container" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(form),
          size: "large",
          "label-width": "120px",
          style: {"width":"1080px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => [
                _hoisted_3
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "选择发票类型:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _unref(form).invoicechoose,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).invoicechoose) = $event)),
                              onChange: invoiceHandler
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, { label: 1 }, {
                                  default: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, { label: 2 }, {
                                  default: _withCtx(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_unref(form).invoicechoose == '3')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "选择单位:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _unref(form).region,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).region) = $event)),
                                    filterable: "",
                                    remote: "",
                                    clearable: "",
                                    "remote-method": getConfigCompany,
                                    onChange: changeCompany,
                                    loading: loading.value,
                                    style: {"width":"100%"},
                                    placeholder: "选择开票单位"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companys.value, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: index,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "loading"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "公司名称:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).companyname,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).companyname) = $event)),
                                    placeholder: "公司名称"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "发票抬头" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).invoicetitle,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).invoicetitle) = $event)),
                                    placeholder: "发票抬头"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "税号信用代码:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).taxno,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).taxno) = $event)),
                                    placeholder: "税号信用代码"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "联系电话:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).contactphone,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(form).contactphone) = $event)),
                                    placeholder: "联系电话"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "开户银行:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).depositbank,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(form).depositbank) = $event)),
                                    placeholder: "开户银行"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "开户账号:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).bankaccountno,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(form).bankaccountno) = $event)),
                                    placeholder: "开户账号"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "所属区镇:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _unref(form).subdistrict,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(form).subdistrict) = $event)),
                                    style: {"width":"100%"},
                                    placeholder: "选择所属区镇"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(district.value, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: index,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "公司经营地址:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).companyaddress,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).companyaddress) = $event)),
                                    placeholder: "请输入公司经营地址"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "公司注册地址:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).bankaddress,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(form).bankaddress) = $event)),
                                    placeholder: "请输入公司注册地址"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => [
                _hoisted_7
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "培训课程:" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(form).coursename) + "(" + _toDisplayString(_unref(form).stagename) + ") ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "人员/作业类别" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(form).audienceName), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "开班日期:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(form).ddlTrainTime,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).ddlTrainTime) = $event)),
                                onChange: trainTimeHandler,
                                style: {"width":"100%"},
                                placeholder: "选择开班日期"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(periodids.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      value: item.value,
                                      key: index
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "具体上课时间:" }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                textContent: _toDisplayString(openTime.value),
                                style: {"color":"red","font-weight":"bolder"}
                              }, null, 8, _hoisted_9)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "公司名称:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(form).companyname,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(form).companyname) = $event)),
                                placeholder: "公司名称"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "发票抬头" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(form).invoicetitle,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(form).invoicetitle) = $event)),
                                placeholder: "发票抬头"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "所属区镇:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(form).subdistrict,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(form).subdistrict) = $event)),
                                style: {"width":"100%"},
                                placeholder: "选择所属区镇"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(district.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "姓名:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(form).studentname,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(form).studentname) = $event)),
                                placeholder: "姓名",
                                style: {"width":"320px","margin-right":"10px"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: getUserInfo
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_10
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "性别:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                style: {"width":"100%"},
                                modelValue: _unref(form).gender,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(form).gender) = $event)),
                                placeholder: "请选择性别"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, { value: "男" }, {
                                    default: _withCtx(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "女" }, {
                                    default: _withCtx(() => [
                                      _hoisted_12
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "出生年月:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                style: {"width":"100%"},
                                modelValue: _unref(form).birthdate,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(form).birthdate) = $event)),
                                type: "date",
                                format: "YYYY-MM-DD",
                                "value-format": "YYYY-MM-DD",
                                placeholder: "选择出生年月"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "手机号:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(form).phoneno,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(form).phoneno) = $event)),
                                placeholder: "请输入手机号"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "证件类型:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(form).idcardcode,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(form).idcardcode) = $event)),
                                style: {"width":"100%"},
                                onChange: idcardHandler,
                                placeholder: "选择证件类型"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "身份证",
                                    value: "IDC_001"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "港澳台胞证",
                                    value: "IDC_002"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "护照",
                                    value: "IDC_003"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "证件号码:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(form).idcardno,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(form).idcardno) = $event)),
                                placeholder: "请输入证件号码"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "文化程度:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(form).degreecode,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(form).degreecode) = $event)),
                                style: {"width":"100%"},
                                onChange: degreeHandler,
                                placeholder: "选择文化程度"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(degreeCategory.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      value: item.value,
                                      key: index
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "所学专业:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(form).major,
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(form).major) = $event)),
                                placeholder: "请输入所学专业"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "职务:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(form).inchargename,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(form).inchargename) = $event)),
                                placeholder: "请输入职务"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "备注:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(form).nameremark,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(form).nameremark) = $event)),
                                placeholder: "请输入备注内容"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "联系地址:",
                            class: "address",
                            style: {"display":"flex"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                style: {"width":"200px"},
                                modelValue: _unref(form).provincekey,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(form).provincekey) = $event)),
                                onChange: changeProvince,
                                placeholder: "选择省份"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinces.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      value: item.value,
                                      key: index
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_el_select, {
                                style: {"width":"200px"},
                                modelValue: _unref(form).citykey,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(form).citykey) = $event)),
                                onChange: changeDistrict,
                                placeholder: "选择城市"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(citys.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      value: item.value,
                                      key: index
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_el_select, {
                                style: {"width":"200px"},
                                modelValue: _unref(form).districtkey,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(form).districtkey) = $event)),
                                onChange: changeArea,
                                placeholder: "选择区"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(districts.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      label: item.label,
                                      value: item.value,
                                      key: index
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_el_select, {
                                modelValue: _unref(form).townkey,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(form).townkey) = $event)),
                                onChange: townHandler,
                                style: {"width":"200px"},
                                placeholder: "选择所属区镇"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(district.value, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "详细地址:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: _unref(form).kttype,
                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(form).kttype) = $event)),
                            onChange: _ctx.ktType
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { label: 1 }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { label: 2 }, {
                                default: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onChange"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_unref(form).kttype == 2)
                    ? (_openBlock(), _createBlock(_component_el_row, {
                        key: 0,
                        gutter: 20
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "联系地址:",
                                class: "address",
                                style: {"display":"flex"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    style: {"width":"200px"},
                                    modelValue: _unref(form).zsprovincekey,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(form).zsprovincekey) = $event)),
                                    onChange: zschangeProvince,
                                    placeholder: "选择省份"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(provinces.value, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: item.label,
                                          value: item.value,
                                          key: index
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_el_select, {
                                    style: {"width":"200px"},
                                    modelValue: _unref(form).zscitykey,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(form).zscitykey) = $event)),
                                    onChange: zschangeDistrict,
                                    placeholder: "选择城市"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zscitys.value, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: item.label,
                                          value: item.value,
                                          key: index
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_el_select, {
                                    style: {"width":"200px"},
                                    modelValue: _unref(form).zsdistrictkey,
                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(form).zsdistrictkey) = $event)),
                                    onChange: zschangeArea,
                                    placeholder: "选择区"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zsdistricts.value, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: item.label,
                                          value: item.value,
                                          key: index
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]),
                                  _createVNode(_component_el_select, {
                                    style: {"width":"200px"},
                                    modelValue: _unref(form).zstownkey,
                                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(form).zstownkey) = $event)),
                                    onChange: zstownHandler,
                                    placeholder: "选择所属区镇"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(district.value, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: index,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(form).kttype == 2)
                    ? (_openBlock(), _createBlock(_component_el_row, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "收货人:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).ktname,
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(form).ktname) = $event)),
                                    placeholder: "请输入快递收货人"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "收货电话:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).ktphone,
                                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(form).ktphone) = $event)),
                                    placeholder: "请输入快递收货电话"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 8 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "收货地址:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).address,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(form).address) = $event)),
                                    placeholder: "请输入收货地址"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_el_button, {
                    loading: isLoading.value,
                    size: "small",
                    type: "primary",
                    onClick: showCertificate
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(ImgBox, {
                            type: "1",
                            onCallback: setParams,
                            name: "idcardfrontphotopath",
                            key: "idcardfront",
                            item: _unref(form).idcardfrontphotopath,
                            title: "身份证件正面"
                          }, null, 8, ["item"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(ImgBox, {
                            type: "1",
                            onCallback: setParams,
                            name: "idcardbackendphotopath",
                            key: "idcardback",
                            item: _unref(form).idcardbackendphotopath,
                            title: "身份证件反面"
                          }, null, 8, ["item"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(ImgBox, {
                            type: "1",
                            onCallback: setParams,
                            name: "diplomafile",
                            title: "学历证书或证明"
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(ImgBox, {
                            type: "1",
                            onCallback: setParams,
                            name: "profilephotopath",
                            key: "profilephotopath",
                            item: _unref(form).profilephotopath,
                            title: "2寸免冠照片"
                          }, null, 8, ["item"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (isShow.value)
                    ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "资格证号:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(form).certificateno,
                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_unref(form).certificateno) = $event)),
                                    placeholder: "请输入资格证号"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "初次领证时间:" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    style: {"width":"100%"},
                                    modelValue: _unref(form).certificatetime,
                                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(form).certificatetime) = $event)),
                                    format: "YYYY-MM-DD",
                                    "value-format": "YYYY-MM-DD",
                                    type: "date",
                                    placeholder: "选择初次领证时间"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (isShow.value)
                    ? (_openBlock(), _createBlock(_component_el_row, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(ImgBox, {
                                type: "1",
                                onCallback: setParams,
                                name: "certfirst",
                                item: item,
                                title: "操作证正面"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(ImgBox, {
                                type: "1",
                                onCallback: setParams,
                                name: "certsecond",
                                item: item,
                                title: "操作证反面"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 6 }, {
                            default: _withCtx(() => [
                              _createVNode(ImgBox, {
                                type: "1",
                                onCallback: setParams,
                                name: "certthrid",
                                item: item,
                                title: "证书培训内容最近一页"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_row, { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 18 }, {
                          default: _withCtx(() => [
                            _createVNode(ImgBox, {
                              type: "2",
                              onCallback: setParams,
                              name: index,
                              item: item,
                              title: item.title
                            }, null, 8, ["name", "item", "title"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: onSubmit
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, { onClick: backHandler }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(Certificate, {
              item: _unref(form),
              ref_key: "certificate",
              ref: certificate,
              onCallback: hideCertificate
            }, null, 8, ["item"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ]))
}
}

})